import { getLocalTimeZone, today as getToday } from '@internationalized/date';
import { FeatureFlag } from '@/utils/featureFlags';
import { isFeatureEnabled } from '@/utils/featureEnabled';

export const today = getToday(getLocalTimeZone());

const yesterday = today.subtract({ days: 1 });
const lastWeek = today.subtract({ days: 7 });
const lastMonth = today.subtract({ months: 1 });
export const lastYear = today.subtract({ years: 1 });

const past15 = today.subtract({ days: 15 });
const future7 = today.add({ days: 7 });
const future15 = today.add({ days: 15 });
const future30 = today.add({ days: 30 });

export enum DatePresetType {
  Now = 'now',
  Yesterday = 'yesterday',
  Last7Days = 'last7d',
  Last30Days = 'last30d',
  Past15Future15Days = 'past15d-future15d',
  Next7Days = 'next7d',
  Next30Days = 'next30d',
}

const showNewEventsUi = isFeatureEnabled(FeatureFlag.ShowNewEventsUi);

export const defaultPresets = {
  [DatePresetType.Now]: {
    label: 'Today',
    value: '"now/d"/"now/d"',
    rangeDateValue: () => ({ start: today, end: today }),
  },
  [DatePresetType.Yesterday]: {
    label: 'Yesterday',
    value: '"now-1d/d"/"now-1d/d"',
    rangeDateValue: () => ({ start: yesterday, end: yesterday }),
  },
  [DatePresetType.Last7Days]: {
    label: 'Last 7 days',
    value: '"now-7d/d"/"now/d"',
    rangeDateValue: () => ({ start: lastWeek, end: today }),
    preview: `${lastWeek.toString()} to ${today.toString()}`,
  },
  [DatePresetType.Last30Days]: {
    label: 'Last 30 days',
    value: '"now-30d/d"/"now/d"',
    rangeDateValue: () => ({ start: lastMonth, end: today }),
    preview: `${lastMonth.toString()} to ${today.toString()}`,
  },
  ...(showNewEventsUi
    ? {
        [DatePresetType.Past15Future15Days]: {
          label: '±15 days from today',
          value: '"now-15d/d"/"now+15d/d"',
          rangeDateValue: () => ({ start: past15, end: future15 }),
          preview: `${past15.toString()} to ${future15.toString()}`,
        },
        [DatePresetType.Next7Days]: {
          label: 'Next 7 days',
          value: '"now/d"/now+7d',
          rangeDateValue: () => ({ start: today, end: future7 }),
          preview: `${today.toString()} to ${future7.toString()}`,
        },
        [DatePresetType.Next30Days]: {
          label: 'Next 30 days',
          value: '"now/d"/now+30d',
          rangeDateValue: () => ({ start: today, end: future30 }),
          preview: `${today.toString()} to ${future30.toString()}`,
        },
      }
    : {}),
};
